(ns manatee.edit.handlers
  (:require [ajax.edn :refer [edn-response-format]]
            [cemerick.url :refer [url]]
            [kee-frame.core :as kf]
            [manatee.admin.app-db :as adm-db]
            [manatee.admin.handlers :as-alias admin-handlers]
            [manatee.admin.task-config.app-db :as tc-db]
            [manatee.edit.app-db :as db]
            [manatee.qa.app-db :as qa-db]
            [manatee.user.handlers :as user-handlers]
            [medley.core :as medley]
            [re-frame.core :as rf]
            [rothko.dom.url :as url]))

(defn load-edits-query-params
  [params tids-by-name]
  (let [tab (get params "tab" (:tab params))
        filters (get params "filters" (:filters params))
        pagination (get params "pagination" (:pagination params))
        task-ids (seq (apply concat (map tids-by-name (:tasks filters))))]
    {:pagination pagination
     :filters (cond-> (dissoc filters :tasks)
                task-ids (assoc :task-ids task-ids))
     :tab tab
     :edit-source tab}))

(rf/reg-event-db
 ::set-table-component-loading
 (fn set-table-component-loading
   [db [_ loading?]]
   (db/set-table-component-loading db loading?)))

(rf/reg-event-fx
 ::load-edits-view
 [(rf/inject-cofx :current-url)]
 (fn load-edits-view
   [{:keys [db current-url]} [_ initial-tab pagination]]
   (let [params (-> (url current-url)
                    :query
                    (url/query-params->edn)
                    (assoc :tab initial-tab :pagination pagination))
         tids-by-name (tc-db/get-task-ids-by-name db)
         query-params (load-edits-query-params params tids-by-name)]
     {:db (db/set-selected-tab db initial-tab)
      :dispatch-n [[::load-edits query-params]
                   [::admin-handlers/load-users-if-not-loaded]]})))

(kf/reg-controller ::edits-controller
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::edits)
                                params))
                    :start (fn [_ params]
                             (let [tab (get-in params [:query :tab] :completed)]
                               (when params
                                 [::load-edits-view (keyword tab) {:page 1 :size 50}])))})

(defn- filters->api
  [team-filter aihyb-filter]
  (prn [team-filter aihyb-filter])
  (and team-filter
       {:filters {:team
                  (case team-filter
                    :no-team-filter nil
                    :no-team "no-team"
                    (str team-filter))

                  :aihyb? aihyb-filter}}))

(rf/reg-event-fx
 ::load-edits
 (fn load-edits
   [{:keys [db]} [_ params]]
   (let [params (if (map? params) params (db/table-params db))
         selected-tab (db/selected-tab db)
         tids-by-name (tc-db/get-task-ids-by-name db)
         query-params (-> params
                          (assoc "tab" selected-tab)
                          (load-edits-query-params tids-by-name)
                          ((partial merge-with merge)
                           (if (= selected-tab :compare)
                             (db/compare-options db)
                             (filters->api (adm-db/get-team-filter db)
                                           (qa-db/get-aihyb-filter db)))))]
     (when selected-tab
       {:db         (db/set-table-component-loading db true)
        :http-xhrio {:method          :get
                     :uri             (str (assoc (url (kf/path-for [:api/edits])) :query query-params))
                     :on-failure      [::load-edits-failure]
                     :on-success      [::persist-table-params query-params]
                     :response-format (edn-response-format)}}))))

(rf/reg-event-fx
 ::persist-table-params
 (fn persist-table-params
   [{:keys [db]} [_ params result]]
   {:db (db/set-table-params db params)
    :dispatch [::load-edits-success result]}))

(rf/reg-event-db
 ::load-edits-success
 (fn load-edits-success
   [db [_ {:keys [edits edit-source total user-viewed-items]}]]
   (let [edits (map #(update % :user user-handlers/user<-api) edits)]
     (-> db
         (db/set-edits-by-ident edit-source edits)
         (qa-db/set-viewed-items user-viewed-items)
         (db/set-table-component-loading false)
         (assoc-in [:table edit-source :edits] {:edit-idents (map (juxt :user-id :item-id) edits)
                                                :total total})))))

(rf/reg-event-fx
 ::load-edits-failure
 (fn load-edits-failure
   [{:keys [db]} _]
   {:db (db/set-table-component-loading db false)}))

(rf/reg-event-fx
 ::select-tab
 (fn select-tab
   [{:keys [db]} [_ tab]]
   {:db (-> db
            (db/set-selected-tab tab)
            (db/set-edits-by-ident tab []))}))

(rf/reg-event-fx
 ::set-compare-option
 (fn set-compare-option
   [{:keys [db]} [_ k v]]
   (let [old-options (or (db/compare-options db) {})
         new-options (assoc old-options k v)]
     (when (not= (medley/remove-vals nil? old-options)
                 (medley/remove-vals nil? new-options))
       {:db (db/set-compare-options db new-options)
        :dispatch [::load-edits]}))))
